var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { GemElement, html, ifDefined } from '../../lib/element';
import { attribute, property, state, part, connectStore } from '../../lib/decorators';
import { history, basePathStore } from '../../lib/history';
import { absoluteLocation } from '../../lib/utils';
import { matchPath, createHistoryParams, createPath } from './route';
/**
 * @attr href
 * @attr target
 * @attr doc-title
 * @attr path
 * @attr query
 * @attr hash
 * @attr pattern
 * @attr hint
 * @part link
 *
 * print bug: https://github.com/mantou132/gem/issues/36
 */
let GemLinkElement = class GemLinkElement extends GemElement {
    constructor() {
        super();
        this.clickHandle = async (e) => {
            var _a;
            const pathInfo = this.getPathInfo();
            if (!pathInfo)
                return;
            // 外部链接使用 `window.open`
            if (this.isExternal(pathInfo)) {
                switch (this.target) {
                    case '_self':
                        window.location.href = pathInfo;
                        return;
                    case '_parent':
                        window.parent.location.href = pathInfo;
                        return;
                    case '_top':
                        window.top.location.href = pathInfo;
                        return;
                    default:
                        window.open(pathInfo);
                        return;
                }
            }
            const { path, query, hash } = history.getParams();
            if (path + query + hash === pathInfo) {
                // 点击当前路由链接时，什么也没做
                return;
            }
            e.stopPropagation();
            await ((_a = this.prepare) === null || _a === void 0 ? void 0 : _a.call(this));
            if (this.route) {
                history.pushIgnoreCloseHandle({
                    ...createHistoryParams(this.route, this.options),
                    title: this.route.title || this.docTitle,
                });
            }
            else if (this.href) {
                const { pathname, search, hash } = new URL(pathInfo, location.origin);
                history.pushIgnoreCloseHandle({
                    path: pathname,
                    query: search,
                    hash: hash,
                    title: this.docTitle,
                });
            }
            else {
                history.pushIgnoreCloseHandle({ path: this.path, query: this.query, hash: this.hash, title: this.docTitle });
            }
        };
        this.preventDefault = (e) => {
            e.preventDefault();
        };
        this.tabIndex = 0;
        this.addEventListener('click', this.clickHandle);
    }
    // 不包含 basePath
    getPathInfo() {
        var _a, _b;
        if (this.route) {
            const queryProp = ((_a = this.options) === null || _a === void 0 ? void 0 : _a.query) || '';
            const hashProp = ((_b = this.options) === null || _b === void 0 ? void 0 : _b.hash) || '';
            return createPath(this.route, this.options) + queryProp + hashProp;
        }
        else {
            const url = this.href || this.path + this.query + this.hash;
            const { path, query } = history.getParams();
            if (url.startsWith('#')) {
                return `${path}${query}${url}`;
            }
            else if (url.startsWith('?')) {
                return `${path}${url}`;
            }
            else if (url.startsWith('.')) {
                return absoluteLocation(path, url);
            }
            else {
                return url;
            }
        }
    }
    isExternal(pathInfo) {
        return !pathInfo.startsWith('/');
    }
    render(pathInfo = this.getPathInfo()) {
        return html `
      <style>
        :host {
          /* link default style */
          cursor: pointer;
          color: blue;
          text-decoration: underline;
        }
        a {
          all: unset;
          display: contents;
        }
        a:visited {
          color: unset;
        }
      </style>
      <a
        part=${this.link}
        @click=${this.preventDefault}
        href=${ifDefined(this.hint === 'off'
            ? undefined
            : this.isExternal(pathInfo)
                ? pathInfo
                : new URL(history.basePath + pathInfo, location.origin).toString())}
      >
        <slot></slot>
      </a>
    `;
    }
};
__decorate([
    attribute
], GemLinkElement.prototype, "href", void 0);
__decorate([
    attribute
], GemLinkElement.prototype, "target", void 0);
__decorate([
    attribute
], GemLinkElement.prototype, "path", void 0);
__decorate([
    attribute
], GemLinkElement.prototype, "query", void 0);
__decorate([
    attribute
], GemLinkElement.prototype, "hash", void 0);
__decorate([
    attribute
], GemLinkElement.prototype, "docTitle", void 0);
__decorate([
    attribute
], GemLinkElement.prototype, "hint", void 0);
__decorate([
    property
], GemLinkElement.prototype, "route", void 0);
__decorate([
    property
], GemLinkElement.prototype, "options", void 0);
__decorate([
    property
], GemLinkElement.prototype, "prepare", void 0);
__decorate([
    part
], GemLinkElement.prototype, "link", void 0);
GemLinkElement = __decorate([
    connectStore(basePathStore)
], GemLinkElement);
export { GemLinkElement };
/**
 * @attr pattern
 * @state active
 */
let GemActiveLinkElement = class GemActiveLinkElement extends GemLinkElement {
    render() {
        const { path, query, hash } = history.getParams();
        const isMatchPattern = this.pattern && matchPath(this.pattern, path);
        const pathInfo = this.getPathInfo();
        if (isMatchPattern || path + query + hash === pathInfo) {
            this.active = true;
        }
        else {
            this.active = false;
        }
        return super.render(pathInfo);
    }
};
__decorate([
    attribute
], GemActiveLinkElement.prototype, "pattern", void 0);
__decorate([
    state
], GemActiveLinkElement.prototype, "active", void 0);
GemActiveLinkElement = __decorate([
    connectStore(history.store)
], GemActiveLinkElement);
export { GemActiveLinkElement };
//# sourceMappingURL=link.js.map